import React from 'react';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { TbWifiOff } from 'react-icons/tb';
import { useTranslation } from 'react-i18next';

const Offline = () => {
    
    const { t } = useTranslation();
    const { isOnline } = useLayoutContext();

    return (
        <>
            {!isOnline && <div className="fixed w-screen h-screen bg-white bg-opacity-90 flex flex-col z-100 justify-center items-center leading-5">
                <TbWifiOff size={50} className=" mb-1" />
                <span className="font-bold">{t('layout.offline_title')}</span>
                <span className='text-sm'>{t('layout.offline_message')}</span>
            </div>
            }
        </>
    );
};

export default Offline;
